module.exports = __webpack_public_path__ + "img/success_OLD_a.6fd33e5a.gif";